import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoginService } from "../services/login.service";
import { ConfirmationService } from "primeng/api";
import { StringRequest } from "../services/StringRequest";
import { SuPasswordCheck } from "../../../shared/su-password-check";
import * as shajs from "sha.js";
import { SuPasswordResetUpdatePasswordRequest } from "../services/SuPasswordResetUpdatePasswordRequest";

@Component({
	selector: "app-su-password-reset",
	templateUrl: "./su-password-reset.component.html",
	styleUrls: ["./su-password-reset.component.css"],
})
export class SuPasswordResetComponent implements OnInit {
	constructor(private router: Router, private route: ActivatedRoute, private dataService: LoginService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.LinkData = this.route.snapshot.params["SULink"];

		this.loadData();
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	LinkData: string = "";
	Username: string = "";

	NewPassword: string = "";
	ConfirmPassword: string = "";

	ErrorMessage: string = "";

	Inited: boolean = false;
	Disabled: boolean = false;

	Loading: boolean = false;

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////////

	loadData() {
		this.Loading = true;

		var parms: StringRequest = {
			str: this.LinkData,
		};

		var result = this.dataService.SuPasswordResetInfoSelect(parms);
		result.subscribe(
			(response: any) => {
				this.Inited = true;

				if (response.Success == true) {
					this.Username = response.Username;
				} else {
					this.ErrorMessage = response.Msg;
					this.Disabled = true;
				}

				this.Loading = false;
			},
			(error) => {
				this.Loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////

	onUpdate() {
		this.ErrorMessage = "";

		if (this.NewPassword == undefined || this.NewPassword == "") {
			this.ErrorMessage = "Enter Password";
			return;
		}
		if (this.ConfirmPassword == undefined || this.ConfirmPassword == "") {
			this.ErrorMessage = "Confirm Password";
			return;
		}
		if (String(this.NewPassword) != String(this.ConfirmPassword)) {
			this.ErrorMessage = "Passwords don't match";
			return;
		}

		var validPassword = SuPasswordCheck.CheckPassword(this.NewPassword);
		if (validPassword.Success == false) {
			this.ErrorMessage = validPassword.ErrorMessage;
			return;
		}

		this.Loading = true;

		var PasswordHash = String(shajs("sha256").update(this.NewPassword).digest("hex")).toUpperCase();

		var parms: SuPasswordResetUpdatePasswordRequest = {
			Link: this.LinkData,
			NewPassword: PasswordHash,
		};

		var result = this.dataService.SuPasswordResetUpdatePassword(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "resetpassword",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Password was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.router.navigate([""]);
						},
					});
				} else {
					//Error Dialog
					this.confirmationService.confirm({
						key: "resetpassword",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update password: " + response.Msg,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Loading = false;
			},
			(error) => {
				this.Loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////////////
}
